import buttonAlignmentModal from "../../../../src/images/snippets/button-alignment-modal.png";
import buttonAlignmentPage from "../../../../src/images/snippets/button-alignment-page.png";
import * as React from 'react';
export default {
  buttonAlignmentModal,
  buttonAlignmentPage,
  React
};